var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"player-placement","aria-label":_vm.$t('aria.vimeo')}})
}
var staticRenderFns = []

export { render, staticRenderFns }